import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';

export const StyledPlayerWrapper = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
  background: ${({ theme }) => theme.playerBackground};
  position: relative;
`;
